import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getOrderHistory } from '../../../actions/orderActions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { customStyles } from '../../../styles'
import { MainContainer } from '../../containers'
import { ModalHeader } from '../../modals'
import { OrderTab } from './OrderTab'

export const OrderHistoryView = () => {
  const { activeOrders, orderHistory } = useSelector(state => state.order);
  const [authorization] = useLocalStorage('login-token', null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    !orderHistory && dispatch(getOrderHistory(authorization?.token))
  }, [])
  
  const handleNavigate = () => {
    // navigate('/dashboard/content')
    navigate(-1)
  }

  return (
    <MainContainer>
      <ModalHeader text="Tus pedidos" backward color={customStyles.colors.main} action={handleNavigate}/>
      { activeOrders && activeOrders.map(item => ( <OrderTab key={item.id} data={item}/> )) }
    </MainContainer>
  )
}
